module.exports = __webpack_public_path__ + "assets/img/idea.0e6e6290.svg";